{
  "_note": "AUTO-GENERATED by scripts/generate-typography-catalog.mjs — DO NOT EDIT. Source of truth: src/<sourceDir>/typography.ts (TYPE_PAIRS + FONT_FALLBACKS). Regenerate: (cd remotion-service/templates && node scripts/generate-typography-catalog.mjs)",
  "template": "quiz_short",
  "pairs": {
    "default": {
      "display": {
        "family": "Figtree",
        "fallback": "sans-serif",
        "weight": 700,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      },
      "body": {
        "family": "Inter",
        "fallback": "sans-serif",
        "weight": 600,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      }
    },
    "editorial": {
      "display": {
        "family": "Lora",
        "fallback": "serif",
        "weight": 700,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      },
      "body": {
        "family": "Inter",
        "fallback": "sans-serif",
        "weight": 500,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      }
    },
    "clean_modern": {
      "display": {
        "family": "Manrope",
        "fallback": "sans-serif",
        "weight": 700,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      },
      "body": {
        "family": "Manrope",
        "fallback": "sans-serif",
        "weight": 500,
        "italic": false,
        "letterSpacing": null,
        "textTransform": "none"
      }
    }
  }
}
